import { PaymentMethod } from '@40seas/entities/payment-methods';
import { PaymentMethodType } from '@40seas/models';
import Stripe from 'stripe';
import { StableCoinPaymentMethod } from '../stablecoin-payment-method.entity';

export async function cryptoPaymentMethodTypeHandler(
    stripePaymentMethod: Stripe.PaymentMethod,
    partialPaymentMethod?: Partial<PaymentMethod>,
    stripeCharge?: Stripe.Charge,
): Promise<Partial<PaymentMethod>> {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - crypto types not in Stripe TS definitions
    const cryptoDetails = stripeCharge?.payment_method_details?.crypto;

    return {
        methodType: PaymentMethodType.Stablecoin,
        methodTypeFields: {
            walletAddress: cryptoDetails?.buyer_address || '',
            network: cryptoDetails?.network || '',
            currency: cryptoDetails?.token_currency?.toUpperCase() || '',
        } as StableCoinPaymentMethod,
    };
}
